export default __webpack_public_path__ + "static/media/touchTwo.dd4b4862.svg";